import { useApiBase } from "api/base";
import { useCallback } from "react";

export function useGetMovimento() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const getMovimento = useCallback(
        (empresaId: string, pessoaId: string, page: number) => {
            return invocarApi({
                url: `v4/empresa/${empresaId}/movimento?page=${page}&pessoaId=${pessoaId}`,
                method: "GET",
                enviarTokenUsuario: true,
            });
        },
        [invocarApi]
    );

    return {
        ...outrasPropriedades,
        getMovimento,
    };
}